import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import styled from 'styled-components';

const SendBtn = styled(Button)`
  width: 120px;
  height: 36px;
  background: #0bb656 !important;
  border-radius: 36px !important;
  border: none;
  padding: 10px 16px;
  margin-top: 8px !important;
  margin-bottom: 8px !important;

  & p {
    font-family: Apple SD Gothic Neo;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    text-decoration-line: underline;
    color: #ffffff;
  }

  & :hover {
    background: #24be67;
  }
`;

class SelectedCompleteButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  componentWillUnmount() {
    this.state = null;
  }

  onClick = async () => {
    const { onSelectedComplete } = this.props;
    this.setState({ loading: true }, async () => {
      await onSelectedComplete();
      if (this.state) {
        this.setState({ loading: false });
      }
    });
  };

  render() {
    const { loading } = this.state;
    const { currentSelect } = this.props;
    return (
      <SendBtn onClick={this.onClick} loading={loading}>
        <p>제출하기 ({currentSelect})</p>
      </SendBtn>
    );
  }
}

export default SelectedCompleteButton;
